import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptDeactivateAccount = () => {
  return {
    event: GTMEvent.DEACTIVATE_ACCOUNT,
  }
}
